import {Component} from '@angular/core';
/**
 * \@title Exclusive selection
 */
export class ButtonToggleExclusiveExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'button-toggle-exclusive-example',
  templateUrl: 'button-toggle-exclusive-example.html',
  styleUrls: ['button-toggle-exclusive-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function ButtonToggleExclusiveExample_tsickle_Closure_declarations() {
/** @type {?} */
ButtonToggleExclusiveExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ButtonToggleExclusiveExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
